export default "__VITE_ASSET__DJ7QCzoH__"